"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MAX_DELAY_MS = exports.AMZ_SDK_REQUEST_HEADER = exports.AMZ_SDK_INVOCATION_ID_HEADER = exports.DEFAULT_RETRY_ATTEMPTS = void 0;
exports.DEFAULT_RETRY_ATTEMPTS = 3;
exports.AMZ_SDK_INVOCATION_ID_HEADER = 'amz-sdk-invocation-id';
exports.AMZ_SDK_REQUEST_HEADER = 'amz-sdk-request';
exports.DEFAULT_MAX_DELAY_MS = 5 * 60 * 1000;
